import type { PublicFlowInfo, SendAuthCodeResult, VerifyAuthCodeResult } from "@repo/shared/types";
import { get, post } from "./_client";

// The self-start page runs before any session. A failure throws `ApiError`
// carrying the API's `error`, already written in the flow's language.

export function getPublicFlowInfo(flowId: string): Promise<PublicFlowInfo> {
  return get<PublicFlowInfo>(`/public/start/${flowId}/info`);
}

export function sendPublicFlowAuthCode(
  flowId: string,
  clientData: { name: string; email?: string; phone?: string },
  method: "email" | "sms",
): Promise<SendAuthCodeResult> {
  return post<SendAuthCodeResult>(`/public/start/${flowId}/send-code`, { ...clientData, method });
}

export function verifyPublicFlowAuthCode(
  flowId: string,
  clientId: string,
  code: string,
): Promise<VerifyAuthCodeResult> {
  return post<VerifyAuthCodeResult>(`/public/start/${flowId}/verify-code`, { clientId, code });
}
